import { render, staticRenderFns } from "./c_overlay.vue?vue&type=template&id=0a92dff8&"
import script from "./c_overlay.vue?vue&type=script&lang=js&"
export * from "./c_overlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports